import React from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { CITY, TOWN, AGREEMENT_URL } from '../../constants';
import PanelLoading from '../../components/panelLoading';

const PATTERN_EMAIL = /^\w+\.*\w+@(\w+[^\.]+\.){1,5}[a-zA-Z]{2,3}$/;

class Confirm extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: {} };
        this.nextStep = this.nextStep.bind(this);
        this.lastStep = this.lastStep.bind(this);
        this.onOptChange = this.onOptChange.bind(this);
        this.onTextChange = this.onTextChange.bind(this);
        this.isValidated = this.isValidated.bind(this);
    }
    onTextChange(name, e) {
        const value = e.target.value ? e.target.value.trim() : '';
        this.props.updateData({ [name]: value });
    }
    onOptChange(name, value) {
        this.props.updateData({ [name]: value });
        if (name === 'cityCode') {
            this.props.updateData({ 'townCode': TOWN[value][0].value });
        }
    }
    nextStep() {
        if (this.isValidated() === true) {
            this.props.jumpToStep(2);
        }
    }
    lastStep() {
        this.props.jumpToStep(0);
    }
    isValidated() {
        const {
            name,
            phone,
            invType,
            invTitle,
            invTaxNo,
            email,
            address,
            agree
        } = this.props.data;
        const error = {};
        if (!name) {
            error.name = '請填入姓名';
        }
        if (!phone) {
            error.phone = '請填入手機號碼';
        }
        if (/[0-9+-]+/.test(phone) === false) {
            error.phone = '手機格式不符';
        }
        if (!agree) {
            error.agree = '請閱讀並同意點數購買與使用條款';
        }
        if (invType === 5 || invType === 6) {
            if (!email) {
                error.email = '請填入電子信箱';
            }
            if (PATTERN_EMAIL.test(email) === false) {
                error.email = '電子信箱格式不符';
            }
            if (!address) {
                error.address = '請填入地址';
            }
        }
        if (invType === 6) {
            if (!invTitle) {
                error.invTitle = '請填入發票抬頭';
            }
            if (!invTaxNo) {
                error.invTaxNo = '請填入統一編號';
            }
        }
        this.setState({ error: error });
        return Object.keys(error).length === 0;
    }
    render() {
        const {
            name = '',
            phone = '',
            gender = 'M',
            invType = 1,
            invTitle = '',
            invTaxNo = '',
            email = '',
            cityCode = '',
            townCode = '',
            address = '',
            agree = false,
        } = this.props.data;
        const loadingPayerInfo = this.props.loadingPayerInfo;
        const error = this.state.error;
        return (
            <div className="panel panel-default" style={{ marginTop: '30px' }}>
                <div className="panel-heading">Step2. 填寫個人資料</div>
                <div className="panel-body" style={{ position: 'relative' }}>
                    {loadingPayerInfo && <PanelLoading />}
                    <div>
                        <div className={error.name ? 'form-group has-error' : 'form-group'}>
                            <label className="control-label">姓名</label>
                            <input type="text" className="form-control" placeholder="姓名" value={name} onChange={e => this.onTextChange('name', e)} />
                            {error.name && <p className="help-block">{error.name}</p>}
                        </div>
                        <div className={error.phone ? 'form-group has-error' : 'form-group'}>
                            <label className="control-label">行號電話</label>
                            <input type="text" className="form-control" placeholder="手機號碼" value={phone} onChange={e => this.onTextChange('phone', e)} />
                            {error.phone && <p className="help-block">{error.phone}</p>}
                        </div>
                        <div className={error.gender ? 'form-group has-error' : 'form-group'}>
                            <label className="control-label">性別</label><br />
                            <div className="btn-group" style={{ width: '100%' }}>
                                {
                                    [{ id: 'M', name: '男' }, { id: 'F', name: '女' }].map(entry => (
                                        <button key={entry.id}
                                            style={{ width: '50%' }}
                                            onClick={() => this.onOptChange('gender', entry.id)}
                                            className={gender === entry.id ? 'btn btn-pubgame' : 'btn btn-default'}>
                                            {entry.name}
                                        </button>
                                    ))
                                }
                            </div>
                        </div>
                        <div className={error.invType ? 'form-group has-error' : 'form-group'}>
                            <label className="control-label">發票</label><br />
                            <div className="btn-group btn-group-justified">
                                {
                                    [
                                        { id: 1, name: '捐贈' },
                                        { id: 5, name: '二聯式' },
                                        { id: 6, name: '三聯式' }
                                    ].map(entry => (
                                        <div key={entry.id} className="btn-group">
                                            <button
                                                type="button"
                                                onClick={() => this.onOptChange('invType', entry.id)}
                                                className={entry.id === invType ? 'btn btn-pubgame' : 'btn btn-default'}>
                                                {entry.name}
                                            </button>
                                        </div>
                                    ))
                                }
                            </div>
                            {invType === 1 && <p className="help-block">捐贈至陽光基金會</p>}
                            {invType === 5 && <p className="help-block">透過電子信箱寄送電子發票。若當期有中獎發票，將會透過填寫地址寄送紙本發票。</p>}
                            {invType === 6 && <p className="help-block">開立三聯式發票</p>}
                        </div>
                        {
                            invType === 6 &&
                            <div className={error.invTitle ? 'form-group has-error' : 'form-group'}>
                                <label className="control-label">發票抬頭</label>
                                <input type="text" className="form-control" placeholder="發票抬頭" value={invTitle} onChange={e => this.onTextChange('invTitle', e)} />
                                {error.invTitle && <p className="help-block">{error.invTitle}</p>}
                            </div>
                        }
                        {
                            invType === 6 &&
                            <div className={error.invTaxNo ? 'form-group has-error' : 'form-group'}>
                                <label className="control-label">統一編號</label>
                                <input type="text" className="form-control" placeholder="統一編號" value={invTaxNo} onChange={e => this.onTextChange('invTaxNo', e)} />
                                {error.invTaxNo && <p className="help-block">{error.invTaxNo}</p>}
                            </div>
                        }
                        {
                            (invType === 6 || invType === 5) &&
                            <div className={error.address ? 'form-group has-error' : 'form-group'}>
                                <label className="control-label">郵寄地址</label>
                                <div className="row" style={{ padding: '0px 15px' }}>
                                    <div className="col-sm-6 col-xs-12" style={{ padding: '0px' }}>
                                        <Select
                                            clearable={false}
                                            value={cityCode}
                                            options={CITY}
                                            onChange={entry => this.onOptChange('cityCode', entry.value)}
                                        />
                                    </div>
                                    <div className="col-sm-6 col-xs-12" style={{ padding: '0px' }}>
                                        <Select
                                            clearable={false}
                                            value={townCode}
                                            options={TOWN[cityCode]}
                                            onChange={entry => this.onOptChange('townCode', entry.value)}
                                        />
                                    </div>
                                </div>
                                <input type="text" className="form-control" placeholder="郵寄地址" value={address} onChange={e => this.onTextChange('address', e)} />
                                {error.address && <p className="help-block">{error.address}</p>}
                            </div>
                        }
                        {
                            (invType === 6 || invType === 5) &&
                            <div className={error.email ? 'form-group has-error' : 'form-group'}>
                                <label className="control-label">Email</label>
                                <input type="email" className="form-control" placeholder="Email" value={email} onChange={e => this.onTextChange('email', e)} />
                                {error.email && <p className="help-block">{error.email}</p>}
                            </div>
                        }
                        <div className={error.agree ? 'form-group has-error' : 'form-group'}>
                            <label className="control-label">為保障您的權益，請閱讀<a href={AGREEMENT_URL} style={{ color: '#00a0e9' }} rel="noopener noreferrer" target="_blank">點數購買與使用條款</a></label>
                            <br />
                            <button
                                className={agree ? 'form-control btn btn-pubgame btn-block' : 'form-control btn btn-default btn-block'}
                                onClick={() => this.onOptChange('agree', !agree)}>
                                <span
                                    className={agree ? 'glyphicon glyphicon-check' : 'glyphicon glyphicon-unchecked'}
                                    style={{ float: 'left', fontSize: '20px', marginTop: '-2px' }}>
                                </span>
                                我已閱讀並同意
                            </button>
                            {error.agree && <p className="help-block">{error.agree}</p>}
                        </div>
                    </div>
                    <hr />
                    <button className="btn btn-default" onClick={this.lastStep}>上一步</button>
                    <button className="btn btn-pubgame" style={{ float: 'right' }} onClick={this.nextStep}>下一步</button>
                </div>
            </div>
        );
    }
}

export default Confirm;


// WEBPACK FOOTER //
// ./src/containers/shop/confirm.jsx